import React, { Component } from 'react'
import RecentEpisodes from '../components/Podcast/RecentEpisodes';
import { NextSeo } from 'next-seo';
import AppAlertDiv from '../components/Common/AppAlertDiv';
import { appleStoreUrl, playStoreUrl } from '../lib/utils';
import RecentPodcasts from '../components/Common/RecentPodcasts';

export default class RecentlyPlayed extends Component {
    render() {
        return (
            <div>
                <NextSeo
                    title='Accelerated Web Player Recently played'
                    description='Find your recently played episodes here.'
                    noindex={true}
                    nofollow={true}
                // canonical='https://tedapp.ai/recently-played'
                // openGraph={{
                //     type: 'website',
                //     locale: 'en_IE',
                //     url: 'https://tedapp.ai/recently-played',
                //     site_name: 'Accelerated',
                // }}
                // twitter:{
                //     handle: '@handle',
                //     site: '@site',
                //     cardType: 'summary_large_image',
                // }
                />
                <h2>Listening History</h2>
                <hr className='separator' />
                {/* <RecentEpisodes /> */}
                <br />
                <RecentPodcasts />
                {/* <h3>Coming Soon.</h3>
                <AppAlertDiv isHtml={true}
                    message={`<p>Recently Played Books are available on our mobile apps (<a href=${appleStoreUrl}
                            target='_blank' rel="noopener noreferrer">iOS</a> or <a href=${playStoreUrl}
                               target='_blank' rel="noopener noreferrer">Android</a>) for now and will be available on web soon.`} showIcon /> */}

            </div>
        )
    }
}
